import { render, staticRenderFns } from "./StockList_List.vue?vue&type=template&id=84edfeee&"
import script from "./StockList_List.vue?vue&type=script&lang=js&"
export * from "./StockList_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports